import React from "react";
import { Button, Card, List, Modal, notification } from "antd";
import ApiService from "services/api";
import Note from "./note";
import ModalForm from "./form";
import { take } from "lodash";
import { Observer, observer } from "mobx-react";

const NOTES_LIMIT = 2;

class Notes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownAllNotes: false,
    };
  }

  showAllNotes = () => this.setState({ shownAllNotes: true });

  openNoteModal = (note) => {
    this.modal = Modal.info({
      title: note ? "Edit note" : "Add note",
      closable: true,
      footer: null,
      maskClosable: true,
      content: (
        <ModalForm note={note} onSubmit={note ? this.editNote : this.addNote} />
      ),
    });
  };

  componentWillUnmount() {
    this.modal?.destroy();
  }

  editNote = async (note) => {
    try {
      await ApiService.updateNote(this.props.contactId, note.id, note);
      this.modal?.destroy();
      this.props.onUpdate(note);
      notification.success({ message: `Note has be edited` });
    } catch (error) {
      console.log("error", error);
      notification.error({ message: `Note can't be edited` });
    }
  };

  addNote = async (note) => {
    try {
      console.log("note", note);
      const { data } = await ApiService.createNote(this.props.contactId, note);
      console.log("data", data);
      this.props.onAdd(data);
      this.modal?.destroy();
      notification.success({ message: `Note has be added` });
    } catch {
      notification.error({ message: `Note can't be added` });
    }
  };

  deleteNote = async (note) => {
    try {
      await ApiService.deleteNote(this.props.contactId, note.id);
      this.props.onDelete(note);
      notification.success({ message: `Note has be deleted` });
    } catch {
      notification.error({ message: `Note can't be deleted` });
    }
  };

  render() {
    const renderedNotes = take(
      this.props.notes,
      this.state.shownAllNotes ? Infinity : NOTES_LIMIT
    );

    return (
      <Card
        style={{ width: "100vw" }}
        title="Notes"
        extra={[
          <Button
            type="primary"
            onClick={() => this.openNoteModal()}
            style={{
              float: "right",
              backgroundColor: "#52c41a",
              borderColor: "#b7eb8f",
            }}
          >
            Add Note
          </Button>,
        ]}
      >
        <List
          style={{ height: "60vh", overflowY: "scroll" }}
          dataSource={renderedNotes}
          renderItem={(item) => (
            <Observer key={item.id}>
              {() => (
                <Note
                  item={item}
                  onEdit={this.openNoteModal}
                  onDelete={this.deleteNote}
                />
              )}
            </Observer>
          )}
          footer={
            !this.state.shownAllNotes &&
            this.props.notes.length > NOTES_LIMIT && (
              <Button
                style={{ marginTop: 10 }}
                type="link"
                onClick={this.showAllNotes}
              >
                Загрузить все заметки
              </Button>
            )
          }
        />
      </Card>
    );
  }
}

Notes.defaultProps = {
  notes: [],
  contactId: null,
  onUpdate: () => {},
  onAdd: () => {},
  onDelete: () => {},
};

export default observer(Notes);
